<template>
  <div
    v-if="salon && salon.grupos && salon.grupos.length"
    class="stack-grupos"
    :class="{ 'stack-grupos--multi': esMultiple }"
  >
    <v-chip
      v-for="(g, gi) in gruposMostrar"
      :key="(g.id_grupo || gi) + '-' + gi"
      class="chip-fill chip-grupo-item"
      label
      :color="salon.color"
      dark
      @click="$emit('cerrar', g, gi)"
    >
      <v-icon v-if="salon.bajo_alumnaje && gi === 0" color="yellow" class="mr-1">mdi-triangle</v-icon>
      <v-icon v-if="esTeens(g)" color="white" class="mr-1">mdi-human-child</v-icon>
      <v-icon v-if="esTns(g)" color="white" class="mr-1">mdi-human-cane</v-icon>
      <v-icon v-if="salon.relleno && gi === 0" color="yellow" class="mr-1">mdi-label</v-icon>
      <v-icon v-if="g.certi" color="yellow" class="mr-1">mdi-stop-circle</v-icon>
      <v-img
        v-if="g.cerrado"
        src="@/assets/iconos/cerrado.png"
        width="30"
        class="mr-2"
      />
      {{ etiqueta(g) }}
    </v-chip>
  </div>
</template>

<script>
export default {
  name: 'SalonChipStack',
  props: {
    salon: { type: Object, required: true },
  },
  computed: {
    gruposMostrar () {
      const completos = (this.salon && this.salon.gruposCompletos) || []
      if (completos.length) return completos
      // Fallback: un chip con los nombres unidos
      return [{
        nivel: ((this.salon.grupos || []).join(',') || ''),
        alumnos: ((this.salon.alumnos || []).join(',') || '0'),
        grupo: '',
      }]
    },
    esMultiple () {
      return this.gruposMostrar.length > 1
    },
  },
  methods: {
    esTeens (g) {
      const nombre = String((g && (g.grupo || g.nivel)) || '')
      return /TEENS/i.test(nombre)
    },
    esTns (g) {
      const nombre = String((g && (g.grupo || g.nivel)) || '')
      return /TNS/i.test(nombre)
    },
    etiqueta (g) {
      const salonNom = (this.salon && this.salon.name_salon) || ''
      const nivel = String(g.nivel != null ? g.nivel : (g.grupo || ''))
        .replace(/NIVEL/gi, 'L')
      const alumnos = g.alumnos != null ? g.alumnos : 0
      const cap = (this.salon && this.salon.capacidad) || 0
      return `${salonNom} - ${nivel} - ${alumnos}/${cap}`
    },
  },
}
</script>

<style scoped>
.stack-grupos {
  display: flex;
  flex-direction: column;
  gap: 2px;
  width: 100%;
  height: 100%;
  min-height: 100%;
  box-sizing: border-box;
}

.stack-grupos--multi {
  height: auto;
  min-height: 100%;
}

.chip-grupo-item {
  width: 100% !important;
  margin: 0 !important;
  flex: 1 1 auto;
  min-height: 28px;
  height: auto !important;
  border-radius: 10px;
  justify-content: center;
}

.stack-grupos:not(.stack-grupos--multi) .chip-grupo-item {
  height: 100% !important;
  min-height: var(--slot-h, 48px);
}
</style>
